import { Component } from "@angular/core";

import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  Event as RouterEvent,
} from "@angular/router";
import { combineLatest } from "rxjs";
import { StateService } from "./providers/state.service";

@Component({
  // tslint:disable-next-line
  selector: "app-body",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  public showOverlay = true;

  constructor(
    private readonly router: Router,
    private readonly stateService: StateService
  ) {
    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.showOverlay = true;
    }
    if (event instanceof NavigationEnd) {
      this.showOverlay = false;
      this.checkMenuInMobile();
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.showOverlay = false;
      this.checkMenuInMobile();
    }
    if (event instanceof NavigationError) {
      this.showOverlay = false;
      this.checkMenuInMobile();
    }
  }

  ngOnInit() {
    document.body.className =
      "app header-fixed sidebar-fixed aside-menu-fixed aside-menu-hidden";
    combineLatest([this.router.events, this.stateService.navItems$]).subscribe(
      ([event, navItems]: any[]) => {
        if (!(event instanceof NavigationEnd)) return;
        const _url = event.url;
        const _navItems = navItems as Array<any>;
        if (_url === "/") {
          this._setActiveNav(this._findNavItem(_navItems, "/dashboard"));
          return;
        }
        const found =
          this._findNavItem(_navItems, _url) ??
          this._findChildNavItem(_navItems, _url);
        this._setActiveNav(found);
      }
    );
  }

  _findNavItem(navItems: any[], url: string) {
    return navItems.find((item: any) => item?.url === url);
  }

  _findChildNavItem(navItems: any[], url: string) {
    return navItems
      .flatMap((child: any) => child.children)
      .find((i: any) => i?.url === url);
  }

  _setActiveNav(item: any) {
    this.stateService.activeNav$.next(item ?? {});
  }

  checkMenuInMobile() {
    const widthW = window.innerWidth;
    if (widthW <= 991) {
      document.querySelector("body").classList.remove("sidebar-mobile-show");
    }
  }
}
